import { render } from "./OrchestrationView.vue?vue&type=template&id=23dcf078&scoped=true"
import script from "./OrchestrationView.vue?vue&type=script&lang=js"
export * from "./OrchestrationView.vue?vue&type=script&lang=js"

import "./OrchestrationView.vue?vue&type=style&index=0&id=23dcf078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dcf078"]])

export default __exports__